import { h, Component, createRef } from 'preact';
import style from './style.css';
import EducationalModal from '../../buyWithInstacredLanding/educationalModal';
import Dialog from 'preact-material-components/Dialog';

type Props = {
  id: string,
  pageKey: string,
};

class EduModalDialog extends Component<Props> {
  state = {
    shouldShowHtbModal: false,
  };
  componentDidMount() {
    if (this.props.shouldShowDialog) {
      this.dialogRef.MDComponent.show();
    }
  }
  setShouldShowHtbModal = (showHtbModal) => {
    this.setState({
      shouldShowHtbModal: showHtbModal,
    });
  };

  closeEducationalModal = () => {
    this.setState({
      shouldShowHtbModal: false,
    });
  };
  render() {
    return (
      <div
        className={`${style.educationModalDialog} educationalModal`}
        id={this.props.id}>
        <Dialog
          onCancel={() => this.props.closeEducationalModal()}
          ref={(dialogRef) => {
            this.dialogRef = dialogRef;
          }}>
          <Dialog.Body class={style.educationalModalDialogBody}>
            <EducationalModal
              shouldShowHtbModal={this.state.shouldShowHtbModal}
              setShouldShowHtbModal={this.setShouldShowHtbModal}
              pageKey={this.props.pageKey}
            />
            <button
              onClick={() => this.props.closeEducationalModal()}
              className={style.closeEducationalModal}>
              <span className='material-icons closeIcon__3Emb9'>close</span>
            </button>
          </Dialog.Body>
        </Dialog>
      </div>
    );
  }
}

export default EduModalDialog;



// WEBPACK FOOTER //
// ./componentsBICRevamp/common/eduModalDialog/index.js